import SearchBox from "../../../../components/components-library/searchbox";
import ToggleCard from "../../../../components/toggle-cards/toggle_card";
import FilterButton from "../../../../components/ui/filter_button/FilterButton";
import useBeneficiaries from "../bloc/useBeneficiaries";
import multiprofileicon from "../../../../assets/images/multiprofileicon.svg";
import BeneficiaryTable from "./beneficiaryTable";
import { Button, PanelSlider } from "../../../../components/ui";
import AddBeneficiary from "../add-beneficiary/add-beneficiary";
import { useDispatch } from "react-redux";
import { setAddBenefiSteps, setBenPayoutOtp, setOpenBeneficiary, setOpenFilter, setRefId } from "../bloc/beneficiariesSlice";
import cancelIcon from "../../../../assets/images/close.svg";
import Filters from "../filters/filters";
import RefreshButton from "../../../../components/ui/refresh_button/RefreshButton";
import Steps from "../../../../components/steps";

const BeneficiaryPage = () => {

    const dispatch = useDispatch();

    const {
        searchText,
        setSearchText,
        isCollapsed,
        setIsCollapsed,
        openBeneficiary,
        allBeneficiaries,
        openFilter,
        isFilterApplied,
        roleType,
        onRefresh,
        addBenefiSteps
    } = useBeneficiaries();

    const total = allBeneficiaries?.length ?? 0;
    const active = allBeneficiaries?.filter((i) => i.status === 1)?.length ?? 0;

    return (
        <div className="p-20">
            <div className="flex items-center justify-between gap-2">
                <div className="w-[25%]">
                    <SearchBox
                        className="mr-2"
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                        }}
                        placeholder={"Search by Beneficiary Name"}
                    />
                </div>

                <div className="flex flex-1 justify-end gap-2">
                    <RefreshButton
                        onClick={onRefresh}
                    />
                    <FilterButton
                        onClick={() => {
                            dispatch(setOpenFilter(true));
                        }}
                        isFilterApplied={isFilterApplied()}
                    />
                    {(roleType === 'ADMIN' || roleType === 'MANAGER') && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                dispatch(setOpenBeneficiary(true));
                                dispatch(setBenPayoutOtp(0));
                                dispatch(setAddBenefiSteps(1));
                                dispatch(setRefId(''));
                            }}
                        >
                            + Add Beneficiary
                        </Button>
                    )}
                </div>
            </div>
            <div className="mt-5">
                <ToggleCard
                    list={[
                        {
                            label: "Total Beneficiaries",
                            value: String(total),
                            icon: multiprofileicon,
                        },
                        {
                            label: "Number Of Active Beneficiaries",
                            value: String(active),
                            icon: multiprofileicon,
                        }
                    ]}
                    onClick={(val) => {
                        setIsCollapsed(!isCollapsed);
                    }}
                />
            </div>
            <div className="mt-5">
                <BeneficiaryTable />
            </div>

            {openBeneficiary && (
                <PanelSlider
                    direction="right_to_left"
                    open={openBeneficiary}
                    onClose={() => {
                        dispatch(setOpenBeneficiary(false));
                    }}
                    style={{ width: "40vw" }}
                >
                    <div
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        className="panel-content"
                    >
                        <div className="border-b card_space_18 flex items-center justify-between">
                            <div>
                                <h2 className="fs-14 font-bold">Add Beneficiary</h2>
                            </div>
                            <div>
                                <Steps stepCount={2} currentStep={addBenefiSteps} />
                            </div>
                            <div>
                                <img
                                    src={cancelIcon}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={() => {
                                        dispatch(setOpenBeneficiary(false));
                                    }}
                                />
                            </div>
                        </div>
                        <div className="bg-gray-bg">
                            <AddBeneficiary />
                        </div>
                    </div>
                </PanelSlider>
            )}

            {openFilter && (
                <PanelSlider
                    direction="right_to_left"
                    open={openFilter}
                    onClose={() => {
                        dispatch(setOpenFilter(false));
                    }}
                    style={{ width: "40vw" }}
                >
                    <div
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        className="panel-content"
                    >
                        <div className="border-b card_space_18 flex items-center justify-between">
                            <div>
                                <h2 className="fs-14 font-bold">Filters</h2>
                            </div>
                            <div>
                                <img
                                    src={cancelIcon}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={() => {
                                        dispatch(setOpenFilter(false));
                                    }}
                                />
                            </div>
                        </div>

                        <Filters />
                    </div>
                </PanelSlider>
            )}

        </div>
    )
}
export default BeneficiaryPage;